<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function(createElement, context) {
    const vnodes = []
    const { icon, title } = context.props
    if (icon) {
      const elHtml = createElement('i', {
        attrs: {
          'class': icon
        }
      })
      vnodes.push(elHtml)
    }
 
    if (title) {
      const elHtml = createElement('span', {
        attrs: {
          slot: title
        }
      }, title)
      vnodes.push(elHtml)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// Item.vue?8e311eaa